<template>
    <div class="bdmap"  :style="{width:showType ? '100%' : '',marginTop:'20px'}">
        <div class="bdmap_title"  v-if="!showType">
        <div class="businessList-filter-list flex align-cen" style="margin-top:20px">
            <div class="fl-le flex align-cen">
                        <div class="label">搜索地址：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入地址搜索" v-model="keyword" clearable> 
                    </el-input>
                    </div>
               </div>
                 <div class="fl-rt flex align-cen">
                        <div class="label" >详细地址：</div>
                    <div class="el-select1">
                    <el-input placeholder="详细地址" v-model="businessDetail.address" clearable maxlength="20"> </el-input>
                    </div>
                 </div>
                <div class="el-btn mft">
                <div class="public-btn-small-primary" @click="addConfirm">
                      确定
                      </div>
                </div>
         </div>
        </div>
        <div id="mapDiv" class=" map-wrap"></div>
              <!-- <baidu-map
                class="map-wrap"
                :center="mapData.center"
                :zoom="mapData.zoom"
                @ready="mapHandler"
                @click="getLocation"
              >
               <bm-view style="width: 100%; height:100%; flex: 1">
               
               </bm-view>
               
                  <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
                <bm-city-list anchor="BMAP_ANCHOR_TOP_RIGHT"
                @changeAfter="updateRegion"
                ></bm-city-list>
                <bm-geolocation
                  anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                  :showAddressBar="showType ? false : true"
                  :autoLocation="true"
                ></bm-geolocation>
              <bm-local-search :keyword="keyword" :auto-viewport="true" class="abs-city"></bm-local-search>
              </baidu-map> -->
    </div>
</template>
<script>
export default {
    name:'bdmap',
      props:{
        sendformLabelAlign:{
            type:Object,
            default: {} // 默认值
        },
        showType:[String,Number]
    },
      sendformLabelAlign: {
      handler (n, o) {
        this.businessDetail.address = n.address
        this.businessDetail.longitude = n.longi
        this.businessDetail.latitude = n.lati
      },
      deep: true // 深度监听父组件传过来对象变化
    },
    data() {
        return {
           //地址信息(包含坐标信息)
    keyword:'',
    siteArr:[],
      businessDetail:{
            address:'',
            province:'',
            city:'',
            longitude:'',
            latitude:'',
            keyword:''
      },
       gc: '',
      //地图数据
      mapData: {
        //中心坐标
        center: { lng: 0, lat: 0 },
        //缩放级别
        zoom:15
      },
      //BMap类
      BMap: null,
      //地图对象
      map: null
        }
    },
     created(){
      if(this.sendformLabelAlign.address){
        this.businessDetail.address = this.sendformLabelAlign.address
        this.businessDetail.longitude = this.sendformLabelAlign.longi
        this.businessDetail.latitude = this.sendformLabelAlign.lati
      }
      this.siteArr = [
        {
          longitude:this.businessDetail.longitude ,
          latitude:this.businessDetail.latitude
        }
      ]
  },
   mounted() {
    let that = this;
        this.$nextTick(() => {
            this.loadMap();
        });
    },
    methods: {
    
        loadMap(jd, wd) {
            let that = this;
            let zoom = 14;
            //初始化地图对象
            this.map = new T.Map('mapDiv');
            //设置显示地图的中心点和级别
            let lng = '';
            let lat = '';
            if (!jd) {
              lng = this.businessDetail.longitude
              lat = this.businessDetail.latitude
            }else{
              lng = jd
              lat = wd
            }
            this.map.centerAndZoom(new T.LngLat(lng, lat), zoom);
            //创建缩放平移控件对象
            let control = new T.Control.Zoom();
            this.map.addControl(control);
            let menu = new T.ContextMenu({width: 140});
            let txtMenuItem = [
                {
                    text: '放大',
                    callback: function () {
                        that.map.zoomIn()
                    }
                },
                {
                    text: '缩小',
                    callback: function () {
                       that.map.zoomOut()
                    }
                },
                {
                    text: '放置到最大级',
                    callback: function () {
                       that.map.setZoom(18)
                    }
                },
                {
                    text: '查看全国',
                    callback: function () {
                       that.map.setZoom(4)
                    }
                },
                {
                    text: '获得右键点击处坐标',
                    isDisable: false,
                    callback: function (lnglat) {
                        alert(lnglat.getLng() + "," + lnglat.getLat());
                    }
                }
            ];
             for (var i = 0; i < txtMenuItem.length; i++) {

                //添加菜单项
                var item = new T.MenuItem(txtMenuItem[i].text, txtMenuItem[i].callback);
                //item.disable();
                menu.addItem(item);
                if (i == 1 || i == 3) {
                    //添加分割线
                    menu.addSeparator();
                }
            }
            that.map.addContextMenu(menu);
              //创建比例尺控件对象
            let scale = new T.Control.Scale();
            //添加比例尺控件
            this.map.addControl(scale);
               //创建对象
            let ctrl = new T.Control.MapType();
            //添加控件
            this.map.addControl(ctrl);
             //创建图片对象
            var icon = new T.Icon({
                iconUrl: "http://api.tianditu.gov.cn/img/map/markerA.png",
                iconSize: new T.Point(19, 27),
                iconAnchor: new T.Point(10, 25)
            });
            let marker = new T.Marker(new T.LngLat(lng, lat), {icon: icon});
             this.map.addOverLay(marker);
            // this.$nextTick(() => {
            //     that.setPoint();
            // });
        },
           setPoint() {
            const site = this.siteArr;
            let points = [];
            site.forEach((item) => {
                // 创建标注对象
                const marker = new T.Marker(new T.LngLat(item.longitude, item.latitude));
                var lnglat = new T.LngLat(item.lng, item.lat);
                points.push(lnglat);
                console.log(marker, '标记点');
                item.marker = marker;
            });
            this.map.setViewport(points);
        },
    // // 父组件
    // loadmap(jd, wd){
    //         this.point = new BMap.Point(jd, wd);  // 创建点坐标  
    //         this.map.centerAndZoom(this.point, 12);                 // 初始化地图，设置中心点坐标和地图级别 
    //         this.map.clearOverlays() 
    //         var marker = new BMap.Marker(this.point); 
    //         this.map.addOverlay(marker); 
    // },
    //       //地图预处理
    // async mapHandler({ BMap, map }) {
    //   //保存百度地图类
    //   this.BMap = BMap
    //   //保存地图对象
    //   this.map = map
    //   //如果一开始坐标存在(编辑的时候)
    //   if (this.businessDetail.longitude && this.businessDetail.latitude) {
    //     //设置坐标
    //     this.mapData.center.lng = this.businessDetail.longitude
    //     this.mapData.center.lat = this.businessDetail.latitude
    //   } else {
    //     //如果坐标不存在则动态获取当前浏览器坐标（创建的时候）
    //     let geolocation = new BMap.Geolocation()
    //     //获取当前的坐标（使用promise 将异步转换为同步）
    //     await new Promise((resolve) => {
    //       geolocation.getCurrentPosition((r) => {
    //         this.businessDetail.address = r.address.province + r.address.city
    //         this.businessDetail.province = r.address.province
    //         this.businessDetail.city = r.address.city
    //         this.mapData.center.lng = this.businessDetail.longitude =
    //           r.point.lng
    //         this.mapData.center.lat = this.businessDetail.latitude = r.point.lat
    //         resolve()
    //       })
    //     })
    //   }
    //   //创建定位标记
    //   let marker = new BMap.Marker(
    //     new BMap.Point(
    //       this.businessDetail.longitude,
    //       this.businessDetail.latitude
    //     )
    //   )
    //   map.addOverlay(marker)
    // },
    //     // 切换城市
    // updateRegion(){
    //  // 获取地图的中心点
    //             let point = this.map.getCenter()
    //             let that = this
    //             let BMapGL = this.BMap
    //              let geoc = new BMapGL.Geocoder()
    //             // 解析坐标点--获取坐标点所在的区域名称（城市）
    //              geoc.getLocation(point, (rs) => {
    //           //获取地址对象
    //           let addressComp = rs.addressComponents
    //           //拼接出详细地址
    //           this.businessDetail.address =
    //             addressComp.province +
    //             addressComp.city +
    //             addressComp.district +
    //             addressComp.street +
    //             addressComp.streetNumber
    //           this.businessDetail.province = addressComp.province
    //           this.businessDetail.city = addressComp.city
    //            this.businessDetail.longitude = rs.point.lng
    //            this.businessDetail.latitude = rs.point.lat
    //         })
    // },
    //     //在地图上选择区域
    // getLocation(e) {
    //   //设置经度
    //   this.businessDetail.longitude = e.point.lng
    //   //设置纬度
    //   this.businessDetail.latitude = e.point.lat
    //   //百度地图类
    //   let BMapGL = this.BMap
    //   //地图对象
    //   let map = this.map
    //   //清除地图上所有的覆盖物(保证每次点击只有一个标记)
    //   map.clearOverlays()
    //   //创建定位标记
    //   let marker = new BMapGL.Marker(new BMapGL.Point(e.point.lng, e.point.lat))
    //   //将标记添加到地图上
    //   map.addOverlay(marker)
    //   //创建坐标解析对象
    //   let geoc = new BMapGL.Geocoder()
    //   geoc.getLocation(e.point, (rs) => {
    //     //获取地址对象
    //     let addressComp = rs.addressComponents
    //     //拼接出详细地址
    //     this.businessDetail.address =
    //       addressComp.province +
    //       addressComp.city +
    //       addressComp.district +
    //       addressComp.street +
    //       addressComp.streetNumber
    //     this.businessDetail.province = addressComp.province
    //     this.businessDetail.city = addressComp.city
    //   })
      
    // },
    //    // 点击确定
    // addConfirm(){
    //     this.$emit('addInfo', JSON.stringify(this.businessDetail))
       
    // },
    },
}
</script>
<style lang="scss" scoped>
.bdmap{
      border:1px solid #f1f1f1;
      margin-bottom: 60px;
    .bdmap_title{
        margin-bottom: 20px;
            .businessList-filter-list{
      .fl-le{
        width: 50%;
      }
      .fl-rt{
        width: 50%;
      }
      .el-btn{
        width: 100px;
           .public-btn-small-primary{
              height: 32px;
              line-height: 30px;
              font-size: 14px;
              border-radius: 2px;
              font-family: inherit;
              border-width: 1px;
              border-style: solid;
              text-align: center;
              vertical-align: middle;
              box-sizing: border-box;
              cursor: pointer;
              transition: all 0.3s;
              background: #155bd4;
              color: #fff;
            }
      }
              .el-select1{
          padding-left: 20px;
           width: 80%;
          .el-input,.el-cascader{
           width: 80%;
          }
        }
    }
    }
       .map-wrap{
        width: 99%;
        height: 55vh;
        margin: 0 auto;
        border-radius: 5px;
        .abs-city{
          display: none;
        }
    }
}
::v-deep {
  	.BMapLabel {
			border-radius: 5px;
			border: none !important;
			top: -100px !important;
			left: -15px !important;
			background: #fff !important;
			//   background: url('~@/assets/images/jrl-param.png') no-repeat 0 0;
			//  background-size: 100%;

		}

		.BMapLabel:after {
			position: absolute;
			top: 100%; //自适应内容框高度定位
			left: 20px;
			width: 0px; //小尾巴的内容宽度，大小决定是否出现漏斗
			height: 0px; //小尾巴的内容宽度，大小决定是否出现漏斗
			content: '';
			box-sizing: border-box;
			border-top: 10px solid #fff;
			border-left: 10px solid  transparent;
			border-right: 10px solid transparent;
			background: transparent; //继承内容框背景色
			background-position: -20px bottom;
			background-origin: border-box;
		}
    		.bmlaber {
			font-size: 16px;
			color: #00fff6;
			text-align: center;
			padding: 20px 20px;
			width: 100%;
			text-align: center;

			p {
				color: #00fff6;
				text-align: left;
			}

			span {
				color: #00fff6;
				text-align: right;
				display: inline-block;
			}
		}
}
@media (max-width: 640px){
  .bdmap{
   display: none;
    
  }
}
</style>